import { useEffect, useState } from 'react'
import { request } from '@/lib/utils';
import { getPricingCohort, pricingExperimentReady } from '@/lib/pricingExperiment';

export function usePlans() {
  const [plans, setPlans] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    let live = true;
    pricingExperimentReady.finally(() => {
      if (!live) return;
      request(`/plans?cohort=${getPricingCohort()}`)
        .then((p) => {
          const keys = Object.keys(p.limits)

          const limitsWithInfinity = keys.reduce((acc, key) => {
            if (p.limits[key] === null) {
              acc[key] = Infinity
            } else {
              acc[key] = p.limits[key]
            }
            return acc
          }, {})

          setPlans({
            ...p,
            limits: limitsWithInfinity
          })
        })
        .catch(setError)
    })
    return () => { live = false; }
  }, [])

  return { plans, error }
}
